import { DataTable } from "@msuite/ui/table";
import { TimelineWeeklyControls, useTimelineWeeklyControls } from "@msuite/ui/timeline";
import { guardArray } from "@msuite/utils/array";
import { usePartnerTimeline } from "@/hooks/use-partner-timeline";
import type { PartnerPanelBaseProps } from "../types";
import { PartnerTimelineReportsGroupHeader } from "./partner-timeline-reports-group-header";
import { columns } from "./table-config";

export function PartnerTimelineReports({ partnershipId }: PartnerPanelBaseProps) {
	/** Hooks */
	const { currentWeek } = useTimelineWeeklyControls();

	/** Query */
	const { data, isLoading, refetch, queryKey } = usePartnerTimeline({ partnershipId, currentWeek });

	/** Render */
	return (
		<div className="p-1 h-full">
			<DataTable
				data={guardArray(data?.reports)}
				columns={columns}
				persistenceKey="partner-timeline-reports-table"
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				grouping={["reportNumber"]}
				initialColumnVisibility={{
					reportNumber: false,
				}}
				renderGroupHeader={(row) => <PartnerTimelineReportsGroupHeader group={row.original} />}
				menu={
					<TimelineWeeklyControls
						queryKey={queryKey}
						withRefreshButton={false}
					/>
				}
			/>
		</div>
	);
}
